var exports = {
  "j": "PanelList__g0WLHe",
  "c": "Condensed__yYLIaH",
};

module.exports = exports;
